module.exports = __webpack_public_path__ + "assets/color.d6e1d0d9.svg";